import React, {useMemo} from 'react';
import {Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {changeContractState} from "../../redux/actions/contract/contractActions";
import {checkRoles} from "../../functions/checkRoles";
import {showSuccessSnackbar} from "../../redux/actions/userActions";

const TableTabSigners = ({signers, status, number, reload, reloadValue, client}) => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("employee.tableItem.employee")},
        {text: t("employee.tableItem.employeeAgree")},
        {text: t("employee.tableItem.comment")},
    ]

    // Получаем имя клиента для отображения, если согласующий — клиент (без employee)
    const getClientName = () => {
        if (client?.person?.fullName) return client.person.fullName;
        if (client?.person) {
            const {lastName, firstName, secondName} = client.person;
            return [lastName, firstName, secondName].filter(Boolean).join(' ');
        }
        if (client?.legalPerson?.name) return client.legalPerson.name;
        return null;
    }
    const clientName = getClientName();
    const {profile} = useSelector((state) => state.profile);
    const dispatch = useDispatch()
    const isAdmin = checkRoles("SuperAdministrator", "Administrator")

    const canSendForApproval = useMemo(() => {
        if (status !== 'Черновик') return false
        if (!signers?.length) return false
        if (isAdmin) return true
        return signers.some(
            (el) =>
                el?.employee?.userId === profile?.userId || el?.userId === profile?.userId
        )
    }, [status, isAdmin, signers, profile?.userId])

    const sendToSignerHandle = async () => {
        await dispatch(changeContractState(number, 1, 2))
        await dispatch(showSuccessSnackbar("Статус договора изменен!", "success"))
        await reload()
    }

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        {rowName.map((el, idx) => {
                            return <TableCell key={idx}
                                              align="center">{el.text}</TableCell>
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {signers?.length && signers.map((el, idx) => {
                        return <TableRow
                            key={el.id != null ? el.id : `signer-${el.employeeId ?? ''}-${el.userId ?? ''}-${idx}`}
                            hover
                            sx={{
                                '&:last-child td, &:last-child th': {border: 0},
                                cursor: 'pointer'
                            }}>
                            <TableCell align="center">
                                {el?.employee?.fullName || clientName || '—'}
                            </TableCell>
                            <TableCell align="center">
                                {el.isSigned ? 'Да' : 'Нет'}
                            </TableCell>
                            <TableCell align="center">
                                {el.comment ? el.comment : 'Комментарий пуст'}
                            </TableCell>
                        </TableRow>
                        })}
                </TableBody>
            </Table>
            {canSendForApproval && <Button
                sx={{margin: '10px 0 10px 10px'}} onClick={sendToSignerHandle} color="warning" variant="outlined" startIcon={<ReadMoreIcon/>}>
                Отправить на согласование
            </Button>}
        </>
    );
}

export default React.memo(TableTabSigners);
